import { http } from '../utils/http';

// 获取数据源列表
export const reqFetchDatasources = () =>
  http.request({
    url: `/datasource`,
    method: 'GET'
  });

// 根据数据源查询指定的数据源配置
export const reqShowDatasourceConfig = data =>
  http.request({
    url: `/datasource/config`,
    method: 'POST',
    data,
    withUserId: 'DATA'
  });
